<template>
  <teleport to="body">
    <div class="modal">
      <div
        ref="modalLayout"
        :class="{ 'modal__layout': true, 'modal__layout--overflow': modalOverflow }"
      >
        <!-- Modal title and close button -->
        <h1
          class="typo-ignore typo-title"
          :class="joinClasses('modal__title', modifiers)"
        >
          <span>{{ title }}</span>
          <div
            class="modal__close"
            @click="dismissModal"
          >
            <UseSvg
              class="icon icon--small"
              name="close_16"
            />
          </div>
        </h1>

        <!-- Modal content -->
        <div class="modal__content">
          <slot name="content" />
        </div>

        <!-- Modal actions -->
        <div
          v-if="actions"
          class="modal__actions"
        >
          <button
            v-if="hasCancel"
            class="button"
            type="button"
            @click="dismissModal"
          >
            {{ $t("general.cancel") }}
          </button>
          <slot name="actions" />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref } from 'vue';

// Utils
import joinClasses from '@/functions/join_classes';

// Components
import UseSvg from '@/components/generic/use_svg.vue';

defineProps({
  title: { type: String, required: true },
  actions: { type: Boolean, default: false },
  hasCancel: { type: Boolean, default: true },
  modifiers: { type: Array, default: () => [] },
  modalOverflow: { type: Boolean, default: false },
});

const emit = defineEmits(['dismissModal']);
const modalLayout = ref(null);

defineExpose({ modalLayout });

/**
 * Emits the dismiss modal event to parent
 */
function dismissModal() {
  emit('dismissModal');
}
</script>
